import React from "react";

import "./Modal.css";
import Loading from "./Loading";
import CodeViewer from "./CodeViewer";

function Modal(props) {
  let modalContent =
    props.modalState === "loading" ? (
      <Loading />
    ) : (
      <CodeViewer a11y={props.a11y} emailBody={props.emailBody} minified={props.minified} minBody={props.minBody}/>
    );

  return (
    <div className="shade">
      <button className="close" onClick={props.onCloseClick}>
        Close
      </button>
      {modalContent}
    </div>
  );
}

export default Modal;
